import { computed, observable } from 'mobx'
import { DiscountType, RedeemableBy } from '../../../graphQL/generated/enums'
import ModelStore from '../../../shared-lib/stores/ModelStore'
import { getDiscountTextForPromocode } from '../../lib/ExternalPromocodeHelper'
import { $RootStore } from '../../../src/stores/RootStore'

export const defaultData = {
  _id: '',
  code: '',
  customRedeemableExternalClientIds: undefined,
  redeemableBy: RedeemableBy.Anyone,
  treatmentIds: [],
  discountAmount: 0,
  discountType: DiscountType.Monies,
  maxRedemptions: null,
  expiryDate: new Date(),
  active: true,
  professionalId: '',
  applyToAllTreatments: false,
  redeemedBy: [],
}

export const couponColors = [
  'orange',
  'lilac',
  'green',
  'primary',
] as const

export type CouponColor = typeof couponColors[number]

export default class ExternalPromocodeModel extends ModelStore {
  @observable accessor data: Partial<ExternalPromocode> = { ...defaultData }
  fetchMethodName = 'externalPromocode'
  saveMethodName = 'updateExternalPromocode'

  constructor(data: Partial<ExternalPromocode>, rootStore: $RootStore) {
    super(data, rootStore)
    this.merge(data)
  }

  @computed get discountText() {
    const { discountType, discountAmount } = this.data
    return getDiscountTextForPromocode({ discountType, discountAmount }, this.rootStore.i18n)
  }

  @computed get couponColor() {
    if (!this.data.code) return 'green'

    const index = this.data.code.charCodeAt(0) % couponColors.length
    return couponColors[index] || 'green'
  }
}